import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Dialog, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.DialogTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.DialogTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.DialogTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.DialogTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.DialogTypeConst.PLACEHOLDER),
        header: _ctx.getPropertyValue(_ctx.DialogTypeConst.HEADER),
        footer: _ctx.getPropertyValue(_ctx.DialogTypeConst.FOOTER),
        modal: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.MODAL),
        contentStyle: _ctx.getPropertyValue(_ctx.DialogTypeConst.CONTENTSTYLE),
        contentClass: _ctx.getPropertyValue(_ctx.DialogTypeConst.CONTENTCLASS),
        contentProps: _ctx.getPropertyValue(_ctx.DialogTypeConst.CONTENTPROPS),
        rtl: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.RTL),
        closable: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.CLOSABLE),
        dismissableMask: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.DISMISSABLEMASK),
        closeOnEscape: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.CLOSEONESCAPE),
        showHeader: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.SHOWHEADER),
        blockScroll: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.BLOCKSCROLL),
        baseZIndex: _ctx.getPropertyNumberValue(_ctx.DialogTypeConst.BASEZINDEX),
        autoZIndex: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.AUTOZINDEX),
        position: _ctx.getCatalogValue(_ctx.DialogTypeConst.POSITION),
        maximizable: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.MAXIMIZABLE),
        breakpoints: _ctx.getPropertyValue(_ctx.DialogTypeConst.BREAKPOINTS),
        draggable: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.DRAGGABLE),
        keepInViewPort: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.KEEPINVIEWPORT),
        minX: _ctx.getPropertyNumberValue(_ctx.DialogTypeConst.MINX),
        minY: _ctx.getPropertyNumberValue(_ctx.DialogTypeConst.MINY),
        closeIcon: _ctx.getPropertyValue(_ctx.DialogTypeConst.CLOSEICON),
        maximizeIcon: _ctx.getPropertyValue(_ctx.DialogTypeConst.MAXIMIZEICON),
        minimizeIcon: _ctx.getPropertyValue(_ctx.DialogTypeConst.MINIMIZEICON),
        unstyled: _ctx.getPropertyBooleanValue(_ctx.DialogTypeConst.UNSTYLED),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, {
        header: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header")
        ]),
        footer: _withCtx(() => [
          _renderSlot(_ctx.$slots, "footer")
        ]),
        closeicon: _withCtx(() => [
          _renderSlot(_ctx.$slots, "closeicon")
        ]),
        maximizeicon: _withCtx(() => [
          _renderSlot(_ctx.$slots, "maximizeicon")
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "header", "footer", "modal", "contentStyle", "contentClass", "contentProps", "rtl", "closable", "dismissableMask", "closeOnEscape", "showHeader", "blockScroll", "baseZIndex", "autoZIndex", "position", "maximizable", "breakpoints", "draggable", "keepInViewPort", "minX", "minY", "closeIcon", "maximizeIcon", "minimizeIcon", "unstyled", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.DialogTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}